module.exports = __webpack_public_path__ + "public/img/ustbg.c35d3a3b.png";